import { axios } from '@/common/api.service.js'

console.log('HERE RacesJS')
//---------------
// set state
//---------------
const state = () => ({
  races: [],
  character_races: [],
  characteristics: [],
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})
//---------
// getters
//---------
const getters = {
  //----------
  // get races
  //-----------
  getRaces(state) {
    return state.races
  },
  //------------------
  // get race by name
  //------------------
  getRaceByName: (state) => (name) => {
    let race = state.races.find((a) => a.name == name)
    try {
      return race
    } catch {
      return null
    }
  },
  //-----------------
  // get race by id
  //-----------------
  getRaceById: (state) => (id) => {
    let race = state.races.find((a) => a.id == id)
    if (!race) {
      race = state.character_races.find((a) => a.id == id)
    }
    try {
      return race
    } catch {
      return null
    }
  },
  //---------------------
  // get character races
  //---------------------
  getCharacterRaces(state) {
    return state.character_races
  },
  //--------------------------
  // get race characteristics
  //--------------------------
  getRaceCharacteristics: (state) => (id) => {
    let race = state.races.find((a) => a.id == id)
    if (!race) {
      race = state.character_races.find((a) => a.id == id)
    }
    try {
      return race.characteristics
    } catch {
      return null
    }
  },
  //---------------------
  // get characteristics
  //---------------------
  getCharacteristics(state) {
    return state.characteristics
  },
  //-------------
  // get headers
  //-------------
  getHeaders(state) {
    return state.headers
  },
}
//---------
// actions
//---------------
const actions = {
  //===============================================================
  // load static character races
  //-----------------------------
  async loadStaticCharacterRaces({ commit, state }) {
    // console.log("-----------------------")
    // console.log("JS loadStaticCharacterRaces..")
    const endpoint = 'api/v1/races/character-races/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setCharacterRaces', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // load static races
  //-------------------
  async loadStaticRaces({ commit, state }, forceReload = false) {
    if (!forceReload && Array.isArray(state.races) && state.races.length > 0) {
      return
    }
    // console.log("-----------------------")
    // console.log("JS loadStaticRaces..")
    const endpoint = 'api/v1/races/?limit=1000'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setRaces', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // load static characteristics
  //-----------------------------
  async loadStaticCharacteristics({ commit, state }) {
    // console.log("----------------------------------");
    // console.log("JS loadStaticCharacteristics..");
    const endpoint = 'api/v1/characteristics/'
    const headers = state.headers
    await axios
      .get(endpoint, {
        headers: headers,
        mode: 'same-origin',
      })
      //--------------
      // where api ok
      //--------------
      .then((response) => {
        commit('setCharacteristics', response.data.results)
      })
      //-----------------
      // where api error
      //-----------------
      .catch((err) => {
        throw window.getErrorMessage(err)
      })
  },
  //===============================================================
  // edit race (add/change)
  //------------------------
  editRace({ state }, parm) {
    // console.log("---------------------")
    // console.log("IN editRace....")

    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios({
        method: parm.api_request.method,
        url: parm.api_request.endpoint,
        headers: headers,
        data: parm.payload,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch(() => {
          reject()
        })
    })
  },
  //===============================================================
  // edit race characteristic (add/change)
  //---------------------------------------
  editRaceCharacteristic({ state }, parm) {
    console.log('---------------------')
    console.log('IN editRaceCharacteristic....')

    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios({
        method: parm.api_request.method,
        url: parm.api_request.endpoint,
        headers: headers,
        data: parm.payload,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch(() => {
          reject()
        })
    })
  },
  //===============================================================
  // delete race
  //-------------
  deleteRace(_, request) {
    //   console.log("----------------")
    // console.log("IN deleteRace...")
    return new Promise((resolve, reject) => {
      const headers = state.headers
      axios({
        method: request.method,
        url: request.endpoint,
        headers: headers,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((error) => {
          reject(error)
        })
    })
  },
  //===============================================================
  // change race image (patch)
  //---------------------------
  changeRaceImage(_, parm) {
    const endpoint = 'api/v1/races/' + parm.slug + '/image/'

    return new Promise((resolve, reject) => {
      axios({
        method: 'patch',
        url: endpoint,
        headers: { 'content-type': 'multipart/form-data' },
        data: parm.image_file,
        mode: 'same-origin',
      })
        //----------
        // where ok
        //----------
        .then((response) => {
          resolve(response)
        })
        //-----------------
        // where api error
        //-----------------
        .catch((error) => {
          reject(error)
        })
    })
  },
}
//===============================================================
// mutations
//-----------
const mutations = {
  setRaces(state, payload) {
    state.races = payload
  },
  setCharacterRaces(state, payload) {
    state.character_races = payload
  },
  setCharacteristics(state, payload) {
    state.characteristics = payload
  },
}
//===============================================================
// export
//--------
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
